var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Transform } from 'class-transformer';
import { ArrayMaxSize, IsArray, IsDateString, IsEnum, IsOptional, IsString, IsUUID, } from 'class-validator';
import { PatientDocumentationItemType } from '../enums/patient-documentation-item-type.enum.js';
/** At most this many files on one documentation entry, kept and new together. */
export const MAX_DOCUMENTATION_ATTACHMENTS = 10;
export class CreatePatientDocumentationItemDto {
    patientId;
    appointmentId;
    treatmentPlanId;
    type;
    text;
    /**
     * Files of the replaced entry this version keeps, by `FileUpload` id; new files come
     * as the multipart `files`. Only with `replacesItemId`, and only the predecessor's own.
     * A multipart field sent once arrives as a string, hence the transform.
     */
    keptFileIds;
    authorId;
    replacesItemId;
    struckOutAt;
    struckOutById;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreatePatientDocumentationItemDto.prototype, "patientId", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    __metadata("design:type", String)
], CreatePatientDocumentationItemDto.prototype, "appointmentId", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    __metadata("design:type", String)
], CreatePatientDocumentationItemDto.prototype, "treatmentPlanId", void 0);
__decorate([
    IsEnum(PatientDocumentationItemType),
    __metadata("design:type", String)
], CreatePatientDocumentationItemDto.prototype, "type", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreatePatientDocumentationItemDto.prototype, "text", void 0);
__decorate([
    IsOptional(),
    Transform(({ value }) => (value === undefined ? undefined : [value].flat())),
    IsArray(),
    ArrayMaxSize(MAX_DOCUMENTATION_ATTACHMENTS),
    IsUUID('all', { each: true }),
    __metadata("design:type", Array)
], CreatePatientDocumentationItemDto.prototype, "keptFileIds", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreatePatientDocumentationItemDto.prototype, "authorId", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    __metadata("design:type", Object)
], CreatePatientDocumentationItemDto.prototype, "replacesItemId", void 0);
__decorate([
    IsOptional(),
    IsDateString(),
    __metadata("design:type", Object)
], CreatePatientDocumentationItemDto.prototype, "struckOutAt", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    __metadata("design:type", Object)
], CreatePatientDocumentationItemDto.prototype, "struckOutById", void 0);
//# sourceMappingURL=create-patient-documentation-item.dto.js.map